import React from "react";
import { Row } from "react-bootstrap";
var PromoterFeedback = function (props) {
    var ratingReason = function (ratingReason) {
        return ratingReason.split("<BR>").map(function (x) {
            var startIndex = x.indexOf("--");
            var endIndex = x.indexOf("--", startIndex) + 1;
            if (startIndex && endIndex)
                return (React.createElement(React.Fragment, null,
                    " ",
                    x.substring(0, startIndex),
                    " ",
                    React.createElement("span", { className: "fw-bolder" },
                        " ",
                        x.substring(startIndex, endIndex + 7),
                        " "),
                    " ",
                    x.substring(endIndex + 7),
                    " "));
            return React.createElement(React.Fragment, null, x);
        });
    };
    return (React.createElement(React.Fragment, null, props === null || props === void 0 ? void 0 : props.feedBackData.map(function (item) {
        return (React.createElement(React.Fragment, null,
            React.createElement(Row, { className: "DMSans_13_400 txt_blackOne1 promoter-feed" },
                React.createElement("label", { className: "DMsanR_11_400 txt-thick_grey" }, item.monthYear),
                React.createElement("div", { className: "feedback-container" }, ratingReason(item.ratingReasonData).map(function (item) { return (React.createElement("p", null, item)); })))));
    })));
};
export default PromoterFeedback;
